

























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import QRcode from '@/components/QRcode/index.vue'

@Component({
  name: 'Tabs',
  components: {
    QRcode
  }
})
export default class Tabs extends Vue {
  /**
   * @param {array} list Tab数据
   * @description: 默认空数组
   */
  @Prop({
    type: [String, Number],
    default: 12
  }) value!: string | number

  /**
   * @param {array} list Tab数据
   * @description: 默认空数组
   */
  @Prop({
    type: Array,
    default: () => ([])
  }) list!: Array<any>

  @Emit()
  input<T> (name: T): T {
    return name
  }

  @Emit('change')
  changeItem (newData: number | string) {
    return newData
  }

  dialogVisible = false

  // 激活索引
  get active (): number | string {
    return this.value
  }

  set active (newData: number | string) {
    this.input(newData)
    this.changeItem(newData)
  }

  clickTabItem (index: number | string): void {
    this.active = index
  }
}
